export const modifyLocaleParam = (locale: string) => {
  const hyphen = '-';
  const language = locale.substring(0, 2);
  const country = locale.substring(3, 5).toLowerCase();

  return language.concat(hyphen, country);
};
